import { render, staticRenderFns } from "./CallcenterTerminbestaetigung.vue?vue&type=template&id=623bb9ba"
import script from "./CallcenterTerminbestaetigung.vue?vue&type=script&lang=js"
export * from "./CallcenterTerminbestaetigung.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports